import type { ReactNode } from 'react';

type SimpleHeroProps = {
  description?: string;
  image?: ReactNode;
  title?: string;
};

export const SimpleHero = ({ description, image, title }: SimpleHeroProps) => (
  <div className="lg:flex bg-base-100 sm:rounded-lg pt-3 px-8 pb-3 relative mb-10 clearfix">
    {title || description ? (
      <div className="md:ml-10 text-center flex justify-center !max-w-full prose-headings:mb-0 flex-col flex-1 sm:text-left prose sm:prose-sm xl:prose-lg">
        {title ? <h1 className="mb-2">{title}</h1> : null}
        {description ? <p className="lead">{description}</p> : null}
      </div>
    ) : null}
    {image ? <div className="mt-6 w-full lg:mt-0 lg:w-[435px] lg:-mt-7">{image}</div> : null}
  </div>
);
